import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import InfiniteList from '../infinite-list';
import Comment from '../comment';
import CommentEditForm from '../../containers/comment-edit-form';
import { HorizontalSeparator } from '../separator';
import withDeviceType from '../../hoc/with-device-type';
import withExperiment from '../../hoc/with-experiment';
import { EXPERIMENT_TOP_COMMENT } from '../../constants/experiments';
import styles from './comment-list.scss';

const THRESHOLD = 400;

const CommentList = ({
  comments,
  onLikeClick,
  onReplyClick,
  reportBottomPosition,
  isMobile,
  editedCommentId,
  topCommentId,
  isTopCommentExperimentEnabled,
}) =>
  <div id="comments" className={styles.commentList}>
    <InfiniteList
      length={comments.length}
      itemRenderer={itemRenderer({
        comments,
        onLikeClick,
        onReplyClick,
        reportBottomPosition,
        isMobile,
        editedCommentId,
        topCommentId,
        isTopCommentExperimentEnabled,
      })}
      threshold={THRESHOLD}
    />
  </div>;

function itemRenderer({
  comments,
  onLikeClick,
  onReplyClick,
  reportBottomPosition,
  isMobile,
  editedCommentId,
  topCommentId,
  isTopCommentExperimentEnabled,
}) {
  return index => {
    const isLast = index === comments.length - 1;
    const comment = comments[index];
    const key = comment._id;
    const isTopComment = isTopCommentExperimentEnabled && comment._id === topCommentId;

    const result = [
      editedCommentId === comment._id ?
        renderCommentForm({ key, comment }) :
        renderComment({ key, index, comment, reportBottomPosition, onLikeClick, onReplyClick, isTopComment }),
    ];
    if (isMobile && !isLast) {
      result.push(<HorizontalSeparator className={styles.separator} key={`${key}-separator`}/>);
    }
    return result;
  };
}

/* eslint-disable react/prop-types */
function renderCommentForm({ key, comment }) {
  return <CommentEditForm key={key} comment={comment}/>;
}
/* eslint-enable react/prop-types */

/* eslint-disable react/prop-types */
function renderComment({ key, index, comment, reportBottomPosition, onLikeClick, onReplyClick, isTopComment }) {
  return (
    <Comment
      reportBottomPosition={index === 0 ? reportBottomPosition : null}
      key={key}
      comment={comment}
      isTopComment={isTopComment}
      onLikeClick={onLikeClick}
      onReplyClick={onReplyClick}
    />
  );
}
/* eslint-enable react/prop-types */

CommentList.propTypes = {
  comments: PropTypes.array.isRequired,
  onLikeClick: PropTypes.func.isRequired,
  onReplyClick: PropTypes.func,
  reportBottomPosition: PropTypes.func,
  isMobile: PropTypes.bool,
  editedCommentId: PropTypes.string,
  topCommentId: PropTypes.string,
  isTopCommentExperimentEnabled: PropTypes.bool,
};

export default flowRight(
  withDeviceType,
  withExperiment({ isTopCommentExperimentEnabled: EXPERIMENT_TOP_COMMENT }),
)(CommentList);



// WEBPACK FOOTER //
// ./app/components/comment-list/comment-list.js